module.exports = __webpack_public_path__ + "media/images/fun-9229fdc980d863adf75e9bd1ce1df7b1.png";